import React from 'react'

import { Helmet } from 'react-helmet'

import NavbarInteractive from '../components/navbar-interactive'
import Footer from '../components/footer'
import './heilige-wandelingen.css'

const HeiligeWandelingen = (props) => {
  return (
    <div className="heilige-wandelingen-container1">
      <Helmet>
        <title>Heilige wandelingen - marjangerrits.nl</title>
        <meta name="description" content="marjangerrits.nl" />
        <meta
          property="og:title"
          content="Heilige wandelingen - marjangerrits.nl"
        />
        <meta property="og:description" content="marjangerrits.nl" />
      </Helmet>
      <NavbarInteractive rootClassName="navbar-interactiveroot-class-name6"></NavbarInteractive>
      <div className="heilige-wandelingen-blogtitel-en-datum">
        <div className="heilige-wandelingen-container2">
          <h1 className="heilige-wandelingen-titel BlogTitel">
            Heilige wandelingen
          </h1>
        </div>
      </div>
      <div className="heilige-wandelingen-container3">
        <p className="heilige-wandelingen-datum">
          <span>30-09-2022</span>
          <br></br>
        </p>
        <img
          alt="image"
          src="/Blog foto's/boom-1500w.webp"
          className="heilige-wandelingen-foto"
        />
        <span className="heilige-wandelingen-tekst">
          <span>
            Nieuwe rugzak, oude wandelschoenen, autolampen bestickerd. Met de
            ferry gaan we naar Engeland. Links houden, links houden, luidt de
            nieuwe mantra in mijn hoofd. Een knusse cottage in Salisbury omarmt
            ons onmiddellijk als we binnen komen. Het beddengoed ruikt naar de
            kunstmatige unstoppables die ik thuis boycot. Hier mag het, alles
            beter dan de zweetgeur van de vorige vakantieganger.
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
          <br></br>
          <br></br>
          <span>
            Vanuit het postzegeltuintje zien we de punt van een wereldberoemde
            kathedraal. De eerste ochtend ben ik als eerste op en ga naar
            buiten. Langs een drukke weg loop ik naar een poortje. Zodra ik daar
            onderdoor ben, valt een serene rust over mij. Alsof de wereld hier
            anders is, goed is. Ik loop door wat ze ‘The Close’ noemen en als ik
            op een kruising aankom, staat mijn hart stil. De kathedraal staat in
            al haar pracht voor mij. Ik heb veel kerken gezien maar nog nooit is
            mij zo de adem benomen. Ik ga op een bankje zitten. Links staat een
            gedeelte in de steigers, niets is volmaakt. De kathedraal straalt
            een en al liefde uit.
          </span>
          <br></br>
          <span>
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
          <br></br>
          <span>
            De volgende dag gaan we naar Woodhenge om vanaf daar naar Stonehenge
            te lopen. We volgen een smal pad en hopen dat het het juiste is. Na
            een halfuur komen we bij een hek dat het boerenland op gaat. Heel in
            de verte zien we Stonehenge liggen. We twijfelen, moeten we echt
            dwars hier doorheen lopen? Geen boze boer of snuivende stier die ons
            de weg belemmert? Aangezien het de kortste weg naar Stonehenge
            lijkt, trekken we de stoute schoenen aan. Het gebied is licht
            heuvelig waardoor Stonehenge korte tijd uit het zicht verdwijnt.
            Maar dan, terwijl we weer omhoog lopen, rijzen de oeroude kanjers
            van stenen langzaam op in het landschap. Majestueus, adembenemend,
            alweer.
          </span>
          <br></br>
          <span>
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
          <br></br>
          <span>
            Na een kleine aanvaring omdat ik me niet gehoord voelde rijden we
            naar de stenencirkel in Avebury. We gaan zitten en verorberen onze
            meegebrachte lunch op het gras, dicht bij een rij stenen. Rust daalt
            over me neer. We wandelen langs de enorme stenencirkel die het dorp
            omringt. Dan komen we bij een heuvel met vier enorme beuken met
            wortels die als verstrengelde vingers de heuvel vasthouden.
            Levensbomen, schiet door mij heen. De takken zijn versierd met
            linten, wensen, veren. In de verte hoor ik iemand fluit spelen.
            Muziektonen die net zo heilig klinken als ik me voel. Ik zoek in de
            omgeving veertjes en takjes bij elkaar en maak er een mooi pakketje
            van. Op blote voeten klauter ik terug over de wortels en zoek een
            plekje voor mijn kleine offer. Enorme liefde vult mijn hart. En
            plotseling weet ik het: de oude pijn van het niet gehoord worden mag
            ik hier loslaten.
          </span>
        </span>
      </div>
      <div className="heilige-wandelingen-andere-blogs">
        <h2 className="heilige-wandelingen-lees-ook">
          <span>Lees ook:</span>
          <br></br>
        </h2>
        <div className="heilige-wandelingen-laatste3-blogposts">
          <div className="heilige-wandelingen-container4"></div>
          <div className="heilige-wandelingen-container5"></div>
          <div className="heilige-wandelingen-container6"></div>
        </div>
      </div>
      <Footer rootClassName="footerroot-class-name6"></Footer>
    </div>
  )
}

export default HeiligeWandelingen
